
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { PaymentMethod } from "@/models/Subscriptions/Payment/PaymentMethod";
import { mapState } from "vuex";
import { TRANSLATIONS_FETCH } from "@/store/ActionTypes";
import { PaymentMethodType } from "@/models/Subscriptions/Payment/PaymentMethodType";
import SubscriptionRepository from "@/utils/API/SubscriptionRepository";
import vPreLoader from "@/components/vPreLoader.vue";
import VueTelInput from "vue-tel-input";
import { BraintreeCountries } from "@/utils/BraintreeCountries";
import vModal from "@/components/vModal.vue";

Vue.use(VueTelInput);

@Component({
  components: {
    vPreLoader,
    vModal,
  },
  computed: {
    ...mapState({
      localizationState: (state: any) => state.LocalizationModule,
    }),
  },
})
export default class vPaymentMethods extends Vue {
  localizationState: any;

  @Prop() paymentMethodToEdit!: number;

  chosenPaymentMethodId: number = -1;
  paymentMethods: PaymentMethod[] = [];
  isLoading = false;
  braintreeCountries: string[] = BraintreeCountries;
  creditCardToEditCopy = {
    id: -1,
    paymentMethodType: 0,
    isDefault: false,
    details: {},
    billingAddress: {},
  };
  isPaymentMethodChangeConfirmationDialogShown: boolean = false;
  attemptedPaymentMethodId: number = -1;

  @Watch("chosenPaymentMethodId")
  chosenPaymentMethodUpdated(nextValue: number) {
    this.$emit("chosen", nextValue);
  }

  get creditCards() {
    return this.paymentMethods.filter(
      (x: PaymentMethod) => x.paymentMethodType == PaymentMethodType.CreditCard
    );
  }

  get payPalAccounts() {
    return this.paymentMethods.filter(
      (x: PaymentMethod) => x.paymentMethodType == PaymentMethodType.PayPal
    );
  }

  get translations() {
    return this.localizationState.translations;
  }

  goToPaymentPage() {
    this.$router.push({ name: 'payment', query: { returnUrl: this.$route.path } });
  }

  paymentMethodEdit(cardId: number) {
    return this.paymentMethodToEdit === cardId;
  }

  //set chosen payment method
  chosenPaymentMethod(paymentMethodId: number) {
    if (this.chosenPaymentMethodId != paymentMethodId) {
      this.isPaymentMethodChangeConfirmationDialogShown = true;
      this.attemptedPaymentMethodId = paymentMethodId;
    }
  }

  chosenPaymentMethodConfirmed() {
    this.chosenPaymentMethodId = this.attemptedPaymentMethodId;
    this.attemptedPaymentMethodId = -1;
    this.isPaymentMethodChangeConfirmationDialogShown = false;
  }

  //choose which payment method to edit
  editPaymentMethod(cardId: number) {
    this.$emit("creditCardToEdit", cardId);

    //When editing the credit card make a copy so if the user cancel the edit the card billing adress will return to previous state
    const creditCard = this.creditCards.find((x) => x.id === cardId);

    if (creditCard != null) {
      const copy = {
        ...creditCard,
        billingAddress: { ...creditCard.billingAddress },
        details: { ...creditCard.details },
      };
      this.creditCardToEditCopy = copy;
    }
  }

  //Update the edited credit card
  updateCreditCard(creditCard: PaymentMethod) {
    const updatePaymentMethod = {
      Id: creditCard.id,
      CardholderName: creditCard.details.cardholderName,
      ExpiryMonth: creditCard.details.expiryMonth,
      ExpiryYear: creditCard.details.expiryYear,
      BillingAddress: {
        Country: creditCard.billingAddress.country,
        State: creditCard.billingAddress.state,
        PostalCode: creditCard.billingAddress.postalCode,
        City: creditCard.billingAddress.city,
        AddressLine: creditCard.billingAddress.addressLine,
        PhoneNumber: creditCard.billingAddress.phoneNumber,
        FirstName: creditCard.billingAddress.firstName,
        LastName: creditCard.billingAddress.lastName,
      },
    };

    SubscriptionRepository.updatePaymentMethod(updatePaymentMethod)
      .then(() => {
        this.$snotify.success("Successfully updated.");
        this.editPaymentMethod(-1);
        //List the updated payment methods
        this.loadPaymentMethods();
      })
      .catch((error) => {
        if (error.response)
          this.$snotify.error(error.response.errorMessages[0].userVisibleMessage);
        else this.$snotify.error(this.translations.get("network-error"));
      });
  }

  //Cancel the edit
  cancelEditPaymentMethod(cardId: number) {
    const editedCard = this.paymentMethods.find((x) => x.id === cardId);
    //On cancel return the billing address to previous state
    if (editedCard != null) {
      editedCard.billingAddress = this.creditCardToEditCopy.billingAddress;
      editedCard.details = this.creditCardToEditCopy.details;
    }
    this.editPaymentMethod(-1);
  }

  // Get next 10 years from todays date
  formatedYears() {
    const years = [];
    const todaysDate = new Date();
    let year = todaysDate.getFullYear();
    const lastYear = year + 11;

    for (year; year < lastYear; year++) {
      years.push(year);
    }
    return years;
  }

  loadPaymentMethods() {
    this.isLoading = true;
    SubscriptionRepository.listPaymentMethods()
      .then((response) => {
        this.paymentMethods = response.data.result;

        let defaultPaymentMethod = this.paymentMethods.find(
          (x: PaymentMethod) => x.isDefault
        );

        if (defaultPaymentMethod) {
          this.chosenPaymentMethodId = defaultPaymentMethod.id;
        }
        else if (this.paymentMethods.length > 0) {
          this.chosenPaymentMethodId = this.paymentMethods[0].id;
        }
        this.isLoading = false;
      })
      .catch(() => {
        this.isLoading = false;
      });
  }

  created() {
    this.$store
      .dispatch(TRANSLATIONS_FETCH, {
        category: "pages",
        collections: [
          "common",
          "managesubscription",
          "packages",
          "addons",
          "managePayment",
          "profile",
        ],
      })
      .then(() => {});
    this.loadPaymentMethods();
  }
}
